import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'i18nSelect',
  standalone: true,
  pure: true,
})
export class I18nSelectPipe implements PipeTransform {
  transform<T>(
    object: T | null | undefined,
    de: keyof T,
    en: keyof T,
  ): string {
    if (!object) {
      return '';
    }
    return ($localize.locale === 'en' && object[en] || object[de]) as string;
  }
}
